import { render } from "./Glow20Project.vue?vue&type=template&id=5bffa64e&scoped=true"
const script = {}

import "./Glow20Project.vue?vue&type=style&index=0&id=5bffa64e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bffa64e"]])

export default __exports__